import { Button, Modal } from '@themesberg/react-bootstrap';
import React from 'react';
import { generateRandomId } from '../../utils/string';
import { useTranslation } from 'react-i18next';
import { returnUserReadableLocalDate } from '../../utils/datetime';

const VehicleEditConfirmationModal = (props) => {
  const { updateMode, vehicle, tripsCount, onConfirm, closeModal, showModal } =
    props;
  const { t } = useTranslation();
  return (
    <Modal
      centered
      id={generateRandomId()}
      size="lg"
      show={showModal}
      onHide={closeModal}
    >
      <Modal.Header>
        <Modal.Title className="h6">
          {t(`${updateMode} for ${vehicle?.vehicleNumber}`)}
        </Modal.Title>
        <Button variant="close" aria-label="Close" onClick={closeModal} />
      </Modal.Header>

      <Modal.Body>
        {updateMode === 'EditVehicle' ? (
          <>
            <div>
              You are about to update the details of vehicle{' '}
              <strong>{vehicle.vehicleNumber}</strong> for the dates selected.
              <br />
              From Date:{' '}
              <strong>{returnUserReadableLocalDate(vehicle.fromDate)}</strong>
              <br />
              To Date:{' '}
              <strong>
                {vehicle.toDate
                  ? returnUserReadableLocalDate(vehicle.toDate)
                  : 'Ongoing'}
              </strong>
            </div>
            <div className="mt-3">
              No of trips where vehicle details will change:{' '}
              <strong>{tripsCount.unpaid || 0}</strong>
            </div>
          </>
        ) : (
          <>
            <div>
              You are about to update the payment details of vehicle{' '}
              <strong>{vehicle.vehicleNumber}</strong> for the dates selected.
              <br />
              From Date:{' '}
              <strong>{returnUserReadableLocalDate(vehicle.fromDate)}</strong>
              <br />
              To Date:{' '}
              <strong>
                {vehicle.toDate
                  ? returnUserReadableLocalDate(vehicle.toDate)
                  : 'Ongoing'}
              </strong>
            </div>
            <div className="mt-2 mb-2">
              Note: This update will be only effective for trips that are not
              invoiced or where amount is manually entered!
            </div>
            <div style={{ backgroundColor: '#F0F0F0' }}>
              <div className="d-flex justify-content-between align-items-center p-2">
                <div>
                  <strong>Invoiced Trips: </strong>
                  {tripsCount.invoiced}
                </div>
                <div className="text-danger">Updates will not apply</div>
              </div>
              <div className="d-flex justify-content-between align-items-center p-2">
                <div>
                  <strong>Unpaid Trips : </strong>
                  {tripsCount.unpaid}
                </div>
                <div className="text-success">Updates will apply</div>
              </div>
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex">
          <Button
            style={{ backgroundColor: '#F0F0F0' }}
            className="mx-2 mt-3"
            variant="outline"
            onClick={() => closeModal()}
          >
            {t('Go Back')}
          </Button>
          <Button
            className="mx-2 mt-3 text-nowrap"
            variant="primary"
            onClick={onConfirm}
          >
            {t(`Save Changes`)}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default VehicleEditConfirmationModal;
